/** Copy of the globalShipments page (Operations), ported from VentaHub. */
export const globalShipments = {
  title: 'Global shipments',
  description:
    'Vendor orders on their way from an import warehouse to the purchase orders they fill.',
  empty: 'No global shipments to show',
  emptyHint: 'Nothing matches these filters.',
  open: 'Open {{code}}',
  filters: {
    leaving: 'Leaving from',
    arriving: 'Arriving at',
    text: 'Shipment',
    dates: 'Dispatched',
    kind: 'Shipping type',
  },
  types: {
    Air: 'Air',
    Ocean_LCL: 'Ocean (LCL)',
    Ocean_FCL: 'Ocean (FCL)',
  },
  status: {
    planned: 'Planned',
    in_transit: 'In transit',
    delivered: 'Delivered',
  },
  columns: {
    number: 'Shipment',
    status: 'Status',
    route: 'Leaving from → arriving at',
    date: 'Dispatched',
    po: 'Purchase order',
    vo: 'Vendor order',
    voAmount: 'Vendor order value',
    shippingType: 'Shipping type',
    cbm: 'CBM',
    shippingAmount: 'Shipping cost',
    deliveryDate: 'Delivered',
    trackingNumber: 'Tracking number',
    emails: 'Notify',
    comment: 'Comment',
  },
  actions: {
    new: 'New shipment',
    edit: 'Edit',
    delete: 'Delete',
  },
  form: {
    hint: 'Name the vendor order it carries (in the import warehouse) and the purchase order it fills (in the export warehouse). A vendor order can be on one shipment at a time.',
    editTitle: 'Edit {{code}}',
    editHint:
      'The two orders are fixed once saved. To carry a different order, raise a new shipment.',
    ends: 'Carries {{vo}} from {{from}} to {{po}} at {{to}}.',
    choose: 'Choose',
    none: 'None',
    fromWarehouse: 'Import warehouse',
    toWarehouse: 'Export warehouse',
    currency: 'Currency (needed with a cost)',
    emails: 'Notify (emails, comma-separated)',
    needEnds: 'Choose both warehouses and type the vendor order and purchase order codes.',
    needName: 'Give the shipment a name.',
    needFromWarehouse: 'Choose the import warehouse.',
    needToWarehouse: 'Choose the export warehouse.',
    needVo: 'Type the vendor order code.',
    needPo: 'Type the purchase order code.',
    emailsPlaceholder: 'ops@example.com, lead@example.com',
    badNumber: 'CBM and shipping cost must be numbers with up to 4 decimals.',
    needCurrency: 'A shipping cost needs a 3-letter currency.',
    badCurrency: 'Type a 3-letter currency code.',
    saved: 'Shipment {{code}} saved',
  },
  delete: {
    title: 'Delete {{code}}?',
    description:
      'The shipment leaves the list. Its vendor order and purchase order stay as they are, and the vendor order can go on a new shipment.',
    done: 'Shipment {{code}} deleted',
  },
  progress: {
    title: 'Progress',
    description: 'How far this shipment’s orders have got, for the SKUs on its vendor order.',
    empty: 'Nothing to show yet.',
    stage: 'Stage',
    units: 'Units',
    value: 'Value',
    last: 'Latest',
    ordered: 'Ordered from the vendor',
    onPo: 'On the purchase order',
    vendorOrders: 'On all vendor orders for the PO',
    received: 'Received (vendor invoiced)',
    packed: 'Packed for the PO',
    invoiced: 'Invoiced to the retailer',
  },
} as const
